import { NewsLetterHeader } from '@arvesta-websites/icons';

import type { Config } from '../default-config';
import mergeConfig from '../merge-config';

const config: Config = mergeConfig({
  NewsletterHeader: {
    SVG: NewsLetterHeader.AveveAgrarisch,
    className: 'newsletter-svg',
  },
  breadcrumb: {
    display: true,
  },
  button: {
    ctaBanner: { image: 'primary-with-background', text: 'primary' },
    ctaGroup: 'primary',
    shortBanner: 'primary-with-background',
  },
  footer: {
    version: 'V2',
  },
});

export default config;
